module.exports = __webpack_public_path__ + "static/media/logo-parceiro-europa.f2ccc3e8.webp";